import styled from 'styled-components'
import { Color } from 'root-constants'

export const StyledAnswerButtonTransparent = {
  Content: styled.div`
    position: relative;
    display: flex;
    align-items: center;
    min-height: 56px;
    padding: 0 20px 0 48px;
    background-color: transparent;
    border-radius: 30px;
    font-weight: 500;
    font-size: 17px;
    line-height: 24px;
    -webkit-box-shadow: inset 0 0 0 1px ${Color.WHITE};
    box-shadow: inset 0 0 0 1px ${Color.WHITE};

    input:checked + & {
      background: ${Color.GRADIENT};
      -webkit-box-shadow: none;
      box-shadow: none;
    }

    &::after {
      display: block;
      content: '';
      width: 6px;
      height: 6px;
      background-color: ${Color.WHITE};
      position: absolute;
      border-radius: 50%;
      left: 30px;
      top: calc(50% - 3px);
    }
  `,
}
